<template>
    <section>
      <div class="clockContainer">
        <div class="clock" >
          <ul>
          	<!--数据增加1.5倍-->
            <li v-for='(item,index) in String(Math.round(goods*1.5))' class="flipLi" >
              <!--<span v-if="index%3 != 0">-->
                {{item}}
              <!--</span>-->
              <!--<span v-if="index%3 === 0">-->
                <!--,-->
              <!--</span>-->
            </li>
          </ul>
        </div>
      </div>
    </section>
</template>

<script type="text/ecmascript-6">
  export default {
    data () {
      return {
        goods: 0,
        listHeight: [],
        scrollY: 0
      }
    },
    mounted () {
      let that = this
      that.$http.jsonp('http://221.122.119.63:8080/tracker_statistics/statistics/vehiclenum?ak=1e706fc68d966cd554c63a8e800e0daf').then(response => {
        let curNum = response.data.total
        that.goods = curNum
        console.log(curNum)
      }, response => {
        console.log('error')
      })
    }
  }
</script>
<style lang="less" rel="stylesheet/less">
  .clockContainer {
    margin: 0 auto;
  }
  .clock {
    ul {
      margin-left: 15px;
      overflow: hidden;
      li {
        width: 95px;
        float: left;
        margin-right: 15px;
        color: #fff;
        height: 130px;
        background: #276b76;
        border-radius: 5px;
        line-height: 130px;
        font-size: 110px;
        text-align: center;
        font-family: "Helvetica Neue", Helvetica, sans-serif;
        &.comma{
           background: transparent;
           padding: 0;
           color: #fff;
           width: 30px;
         }
         &:last-child {
            margin-right: 0;
          }
      }
    }
  }
  .flip-clock-wrapper ul.comma{
    background: transparent;
    padding: 0;
    color: #fff;
    width: 30px;
  }
  .flip-clock-wrapper ul.comma span {
    position: absolute;
    bottom: 20px;
    left: 0px;
    font-weight: bold;
    font-size: 110px;
  }
  .clockContainer {
    width: 876px;
    height: 188px;
    background: url("../../static/images/flipNum/numbg.png");
    position: relative;
  }
  .clock {
    padding: 30px 45px;
    margin: 0;
  }
  .flip-clock-wrapper {
    width: auto;
  }
  .flip-clock-wrapper ul {
    position: relative;
    float: left;
    margin: 5px;
    width: 90px;
    height: 130px;
    font-size: 80px;
    font-weight: bold;
    line-height: 87px;
    border-radius: 6px;
  }
  .flip-clock-wrapper ul li {
    z-index: 1;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    line-height: 130px;
    text-decoration: none !important;
  }
  .flip-clock-wrapper a {
    cursor: pointer;
    text-decoration: none;
    color: #fff;
  }
  .flip-clock-wrapper ul li a div.up{
    background: linear-gradient(#3f8790,#1c4c54);
    border-radius: 5px 5px 0 0;
  }
  .flip-clock-wrapper ul li a div.down{
    background: linear-gradient(#19454b,#318492);
  }
  .flip-clock-wrapper ul.play li .up .shadow,.flip-clock-wrapper ul li a div div.inn{
    background: transparent;
    font-size: 110px;
    color: #fff;
  }
  .flip-clock-wrapper ul li a div.up:after {
    top: 62px;
    background-color: #000;
  }

</style>




// WEBPACK FOOTER //
// flipnum.vue?2d672852